import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'

interface UpdateAlbumParams {
  id: string
  title?: string
  description?: string
}

const updateAlbum = async ({ id, ...body }: UpdateAlbumParams): Promise<void> => {
  await api.patch(`/albums/${id}`, body)
}

export const useUpdateAlbum = () => {
  const queryClient = useQueryClient()

  return useMutation<void, Error, UpdateAlbumParams>({
    mutationFn: updateAlbum,
    onSuccess: (_data, { id }) => {
      queryClient.invalidateQueries({ queryKey: ['album', id] })
      queryClient.invalidateQueries({ queryKey: ['albums'] })
    },
  })
}
